import { render, staticRenderFns } from "./MenuImporter.vue?vue&type=template&id=ba3acbd0"
import script from "./MenuImporter.vue?vue&type=script&lang=ts"
export * from "./MenuImporter.vue?vue&type=script&lang=ts"
import style0 from "./MenuImporter.vue?vue&type=style&index=0&id=ba3acbd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports